import { NavigateBackLink } from '@exam-center/components';
import { useExamCenter } from '@exam-center/exam-center-details';
import { ExamEventCreationLogic } from '@exam-center/exam-event-creation';
import { getExamEventDetailsTitle, getMonthOrder } from '@exam-center/exam-event-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Flex, PageHeader } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamEventCreatePage() {
  const { year, month } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month/create',
  );

  const { examCenter } = useExamCenter();

  const examCenterCode = examCenter.code;

  const yearNumber = parseInt(year);
  const monthNumber = getMonthOrder(month);

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.CREATE}>
      <PageHeader
        title='สร้างรอบสอบใหม่'
        subtitleSection={getExamEventDetailsTitle(yearNumber, month)}
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-events/years/:year/months/:month'
            params={{ examCenterCode, year, month }}
          />
        }
      />
      <Flex
        sx={{
          flexDirection: 'column',
          p: (theme) => theme.spacing(6),
        }}
      >
        <ExamEventCreationLogic
          examCenterCode={examCenterCode}
          year={{
            value: yearNumber,
            param: year,
          }}
          month={{
            value: monthNumber,
            param: month,
          }}
        />
      </Flex>
    </PermissionGuard>
  );
}
